export default [
  { to: 'sjukhus', title: 'Sjukhus' },
  { to: 'primarvard', title: 'Primärvård' },
  { to: 'tandvard', title: 'Tandvård' },
  { to: 'calculator', title: 'SOFA-kalkylator' },
];
